class WDNElement extends HTMLElement {
    constructor() {
        super();

        // shared states between components
        this.setupStates = function () {
            // will create attribute as "data-[array key]""
            var statesToHandle = ['loading', 'disabled', 'active', 'hide'];

            statesToHandle.forEach(function (label) {
                // functions to update state, called like => this.loading(); this.loading(false);
                this[label] = this.updateAttribute(label);
            }, this);
        };

        this.init = function () {
            this.setupStates();
        };

        this.init();
    }

    /* ADDING EVENT LISTENERS FOR LIST OF ITEMS */
    on(event, selector, toDo) {
        /*
       param @event *string
       - name of event you want to listen for,
       e.g.: click, mouseover, etc.
      
       param @selector *string
       - HTML selector to use, can be class, data-attribute etc.
      
       param @toDo *function
       - your function
       */

        var list = this.querySelectorAll(selector);

        list.forEach(function (item) {
            item.addEventListener(event, toDo);
        });
    }

    updateAttribute(name) {
        return function (value) {
            var attrName = 'data-' + name;
            // eg. this.loading(); this.loading(true)
            if (typeof value === 'undefined' || value) {
                this.setAttribute(attrName, '');
            } else {
                this.removeAttribute(attrName);
            }
        }.bind(this);
    }

    // helper function for having a custom events
    customEvent(data) {
        var newEvent = new CustomEvent(data.name, {
            detail: data.detail,
        });
        if (data.target) {
            var target = document.querySelector(data.target);
        }
        if (!target) {
            var target = document.body;
        }
        target.dispatchEvent(newEvent);
    };

    // adds event to window
    addEvent(event, func) {
        return window.addEventListener(event, func);
    };
    // removes event from window
    removeEvent(event, func) {
        return window.removeEventListener(event, func);
    };
}

class WDNOverlay extends WDNElement {
 constructor() {
  super();
  // Config
  this.config = {
   classes: {
    body_open: 'Overlay--open',
    open_vertical: 'Overlay--open-vertical',
    open_horizonal: 'Overlay--open-horizontal',
   },
   version: '1.1',
  };
  // Storing attributes
  this.isOpen = false;
  this.id = this.getAttribute('data-id');
  this.isActive = this.getAttribute('data-active') == '';
  this.animate = this.getAttribute('data-animate');
  // Getting and storing type of the overlay (drawer,modal etc)
  var type = this.getAttribute('type') || 'overlay';
  this.type = type;
  // setup of custom events names
  this.events = {
   open: type + ':opened',
   close: type + ':closed',
  };

  // Event Callbacks
  this.closeOnKeyBound = this.closeOnKey.bind(this);
  this.closeOnClickBound = this.closeOnClick.bind(this);

  // INIT
  this.setupAnimation();
 }

 setActive() {
  this.active();
  this.isActive = true;
  this.appendActiveClasses();
 };

 setInactive() {
  this.active(false);
  this.isActive = false;
  this.removeActiveClasses();
 };

 open() {
  // setting element as active
  this.setActive();
  // Bind window events
  this.bindWindowEvents();
  // fire custom event
  this.customEvent({
   name: this.events.open,
   detail: this,
  });
   this.isOpen = true;
 };

 close() {
  // clearing active state
  this.setInactive();
  // Unbind window events
  this.unbindWindowEvents();
  // fire custom events
  this.customEvent({
   name: this.events.close,
   detail: this,
  });
   this.isOpen = false;
 };

 // listens for ESC key
 closeOnKey(e) {
  if (e.keyCode == 27) {
   this.close();
  }
 };

 // listens for outside click
 closeOnClick(e) {
  // first rule is for drawer, second one is for modal
  if (e.target === document.body || (e.target === this && this.nodeName === 'WDN-MODAL')) {
   this.close();
  }
 };

 // fires whene element is opened
 bindWindowEvents() {
  this.addEvent('keydown', this.closeOnKeyBound);
  this.addEvent('click', this.closeOnClickBound);
 };
 // fires when element is closed
 unbindWindowEvents() {
  this.removeEvent('keydown', this.closeOnKeyBound);
  this.removeEvent('click', this.closeOnClickBound);
 };
 // fires when element is opened
 appendActiveClasses() {
  this.classList.add(this.currentAnimation);
  document.body.classList.add(this.config.classes.body_open);
 };
 // fires when element is closed
 removeActiveClasses() {
  this.classList.remove(this.currentAnimation);
  document.body.classList.remove(this.config.classes.body_open);
 };

 setupAnimation() {
  // By default, overlay opens horizontally
  this.currentAnimation = this.config.classes.open_horizonal;
  if (this.animate === 'top' || this.animate === 'bottom') {
   this.currentAnimation = this.config.classes.open_vertical;
  }
 };
}

/* UNIVERSAL DRAWER/MODAL TRIGGER  */
class WDNOverlayTrigger extends WDNElement {
 constructor() {
  super();
  // drawer/modal id
  this.id = this.getAttribute('data-id');
  // actions - open, close
  this.action = this.getAttribute('action');
  // type can be modal, drawer etc
  this.type = this.getAttribute('type');
  // drawer/modal
  this.element = document.querySelector('wdn-' + this.type + "[data-id='" + this.id + "']");
   
  // INIT
  this.bind();
 }

  handleClick() {
    if (this.action === 'toggle') {
      if (this.element.isOpen) {
        this.element.close();
        return;
      }

      this.element.open();
      return;
    }

    if (this.action === 'close') {
      this.element.close();
    }
    if (this.action === 'open') {
      this.element.open();
    }
  };

 bind() {
  if (this.element) {
   this.addEventListener('click', this.handleClick.bind(this));
  }
 };
}
/* DRAWER CLOSER */
class WDNDrawerClose extends WDNOverlayTrigger {
 constructor() {
  super();
  this.element = document.querySelector("wdn-drawer[data-id='" + this.id + "']");
  this.action = 'close';
  this.bind();
 }
}
/* MODAL CLOSER */
class WDNModalClose extends WDNOverlayTrigger {
 constructor() {
  super();
  this.element = document.querySelector("wdn-modal[data-id='" + this.id + "']");
  this.action = 'close';
  this.bind();
 }
}
/* DRAWER OPENER */
class WDNDrawerOpen extends WDNOverlayTrigger {
 constructor() {
  super();
  this.element = document.querySelector("wdn-drawer[data-id='" + this.id + "']");
  this.action = 'open';
  this.bind();
 }
}

/* MODAL OPENER  */
class WDNModalOpen extends WDNOverlayTrigger {
 constructor() {
  super();
  this.element = document.querySelector("wdn-modal[data-id='" + this.id + "']");
  this.action = 'open';
  this.bind();
 }
}

// Drawer/ Modal
customElements.define('wdn-overlay-trigger', WDNOverlayTrigger);
customElements.define('wdn-drawer', class extends WDNOverlay {});
customElements.define('wdn-modal', class extends WDNOverlay {});
// openers / closers
customElements.define('wdn-drawer-close', WDNDrawerClose);
customElements.define('wdn-modal-close', WDNModalClose);
customElements.define('wdn-drawer-open', WDNDrawerOpen);
customElements.define('wdn-modal-open', WDNModalOpen);
